import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { CREATE_VENDOR, UPDATE_VENDOR } from './queries';
import { TAX_CLASSIFICATIONS } from './new';
import { TAX_ID_TYPES } from './new';
import secrets from '../../../secrets';

const EditVendor = ({setShowModal, refetch, vendor, saleAssetId}) => {
  const [submitting, setSubmitting] = useState();
  const [updateVendor] = useMutation(UPDATE_VENDOR, {
    onCompleted: data => {
      if(refetch) {
        refetch(data);
      }
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    input['saleAssetId'] = saleAssetId;
    if (!input.taxClassification) { input.taxClassification = null; }
    if (!input.taxIdType) { input.taxIdType = null; }
    updateVendor({ variables: input });
  });

  const { control, handleSubmit, register, setValue, formState: { errors } } = useForm({
    defaultValues: {
      id: vendor?.id,
      name: vendor?.name || '',
      street: vendor?.street || '',
      city: vendor?.city || '',
      state: vendor?.state || '',
      postalCode: vendor?.postalCode?.formatted !== null ? vendor?.postalCode?.formatted : '',
      phoneNumber: vendor?.phoneNumber?.formatted !== null ? vendor?.phoneNumber?.formatted : '',
      email: vendor?.email || '',
      notes: vendor?.notes || '',
      taxClassification: vendor?.taxClassification || '',
      llc: vendor?.llc || false,
      taxIdType: vendor?.taxIdType || '',
      taxIdNumber: vendor?.taxIdNumber || ''
    }
  });

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Text
            label="Name:"
            name="name"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Street:"
            name="street"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="City:"
            name="city"
            control={control}
            errors={errors}
          />
          <Input.StatePicker
            label="State:"
            name="state"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Zip:"
            name="postalCode"
            control={control}
            errors={errors}
          />
          <Input.Phone
            label="Phone Number:"
            name="phoneNumber"
            control={control}
            errors={errors}
          />
          <Input.Phone
            label="Email:"
            name="email"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Notes:"
            name="notes"
            control={control}
            errors={errors}
          />
          { secrets.app.doubleEntry &&
            <>

              <Input.Picker
                label="Tax Classification:"
                name="taxClassification"
                options={
                  TAX_CLASSIFICATIONS.map(type => { return { value: type, label: type }})
                }
                control={control}
                errors={errors}
              />
              <Input.Checkbox
                label="LLC?:"
                name="llc"
                control={control}
                errors={errors}
              />
              <Input.Picker
                label="Tax ID Type:"
                name="taxIdType"
                options={
                  TAX_ID_TYPES.map(type => { return { value: type, label: type }})
                }
                control={control}
                errors={errors}
              />
              <Input.Text
                label="Tax ID Number"
                name="taxIdNumber"
                control={control}
                errors={errors}
              />
            </>
          }
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update Vendor" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditVendor;
